import React from "react";
import { useTranslation } from "react-i18next";
import { getExperienceBarWidth } from "./blockHelpers";

const OverviewComponent = ({ program }) => {
  const { t } = useTranslation("coaching-portal");
  const notSingleWorkout = program.storeType !== "single-workout";

  return (
    <>
      {program.difficulty && (
        <div className="exp-wrapper">
          <p className="s1">{t("learnMoreOverview.experienceLevel")}</p>
          <div className="experience-level-container">
            <p className="s3">{t("learnMoreOverview.beginner")}</p>
            <p className="s3">{t("learnMoreOverview.expert")}</p>
          </div>
          <div className="bar">
            <div
              className="progress-filled"
              style={{ width: `${getExperienceBarWidth(program.difficulty)}%` }}
            ></div>
          </div>
        </div>
      )}

      {notSingleWorkout && (
        <div className="blocks-wrapper">
          {program.programs && program.programs.length > 0 ? (
            <>
              <p className="s1">{t("learnMoreOverview.blocksLabel")}</p>
              <ul>
                {program.programs.map((block) => (
                  <li key={`${block.order}-${block.name}`}>
                    <p className="p2">{block.name}</p>
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <p className="p2">{t("learnMoreOverview.noBlocksFound")}</p>
          )}
        </div>
      )}
    </>
  );
};

export default OverviewComponent;
